import React, { Component } from 'react';
import { SaveButton, DeleteButton } from '../modalButtons';

var cardStyle = {
    background: '#fff', border: '1px solid #e0e6ef', borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.07)', padding: '18px 20px',
    display: 'flex', flexDirection: 'column', cursor: 'pointer'
};
var labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '700', letterSpacing: '1px',
    textTransform: 'uppercase', color: '#888', marginBottom: '6px'
};
var inputStyle = {
    width: '100%', padding: '9px 12px', border: '1px solid #ccc', borderRadius: '6px',
    fontSize: '14px', color: '#222', background: '#fff', boxSizing: 'border-box', marginBottom: '16px'
};
var sectionStyle = {
    background: '#f7f9fc', borderRadius: '8px', padding: '14px 16px', marginBottom: '20px'
};

class Actions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingAction: null,
            searchQuery: '',
            error: ''
        };
    }

    cancel = () => {
        this.setState({ editingAction: null, error: '' });
    }

    openAdd = () => {
        this.setState({
            editingAction: { _isNew: true, id: '', name: '', description: '', type: 'custom', endpoint: '', inputs: [], outputs: [] },
            error: ''
        });
    }

    openEdit = (actionId, action) => () => {
        var a = JSON.parse(JSON.stringify(action));
        a._isNew = false;
        if (!a.inputs) a.inputs = [];
        if (!a.outputs) a.outputs = [];
        a.type = 'custom'; // only custom tools for now — no execution-type picker
        if (a.endpoint == null) a.endpoint = '';
        this.setState({ editingAction: a, error: '' });
    }

    editField = (field) => (e) => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a[field] = e.target.value;
        this.setState({ editingAction: a });
    }

    // ── Inputs ────────────────────────────────────────────────────────────────
    addInput = () => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a.inputs.push({ name: '', description: '' });
        this.setState({ editingAction: a });
    }

    editInput = (idx, field, val) => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a.inputs[idx][field] = val;
        this.setState({ editingAction: a });
    }

    removeInput = (idx) => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a.inputs.splice(idx, 1);
        this.setState({ editingAction: a });
    }

    // ── Outputs ───────────────────────────────────────────────────────────────
    addOutput = () => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a.outputs.push({ name: '', description: '' });
        this.setState({ editingAction: a });
    }

    editOutput = (idx, field, val) => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a.outputs[idx][field] = val;
        this.setState({ editingAction: a });
    }

    removeOutput = (idx) => {
        var a = JSON.parse(JSON.stringify(this.state.editingAction));
        a.outputs.splice(idx, 1);
        this.setState({ editingAction: a });
    }

    save = () => {
        var a = this.state.editingAction;
        if (!a.name.trim()) { this.setState({ error: 'Name is required.' }); return; }
        this.props.ws.send(JSON.stringify({ route: 'saveAction', action: a }));
        this.cancel();
    }

    confirmDelete = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteAction', actionId: this.state.editingAction.id }));
        this.cancel();
    }

    render() {
        if (!this.props.active) return <div></div>;

        var actionsData = ((this.props.data.Actions || {}).data) || {};
        var allEntries = Object.entries(actionsData);
        var searchQuery = this.state.searchQuery.toLowerCase().trim();
        var actionEntries = searchQuery
            ? allEntries.filter(function([id, a]) {
                return a.name.toLowerCase().includes(searchQuery)
                    || (a.description || '').toLowerCase().includes(searchQuery)
                    || (a.inputs || []).some(function(f) { return f.name.toLowerCase().includes(searchQuery) || (f.description || '').toLowerCase().includes(searchQuery); })
                    || (a.outputs || []).some(function(f) { return f.name.toLowerCase().includes(searchQuery) || (f.description || '').toLowerCase().includes(searchQuery); });
            })
            : allEntries;
        var chatbotsData = this.props.data.AIChatbots || {};
        var chatbots = chatbotsData.chatbots || {};

        // Count bots using each action
        var usedBy = {};
        Object.values(chatbots).forEach(function(cb) {
            Object.values(cb.bots || {}).forEach(function(bot) {
                (bot.actionIds || []).forEach(function(aid) {
                    usedBy[aid] = (usedBy[aid] || 0) + 1;
                });
            });
        });

        // ── Modal ──────────────────────────────────────────────────────────────
        var modal = null;
        if (this.state.editingAction) {
            var a = this.state.editingAction;
            modal = (
                <div className="blackout" tabIndex="1" autoFocus>
                    <div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '720px', maxWidth: '96vw', padding: '0', overflow: 'hidden' }}>
                        <div className="viewCloser" onClick={this.cancel}></div>
                        <div style={{ background: '#002f5f', padding: '22px 28px 16px', color: '#fff' }}>
                            <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', marginBottom: '5px' }}>
                                {a._isNew ? 'New Action' : 'Edit Action'}
                            </div>
                            <div style={{ fontSize: '21px', fontWeight: '700' }}>{a.name || 'Untitled'}</div>
                        </div>
                        <div style={{ padding: '22px 28px', overflowY: 'auto', maxHeight: 'calc(80vh - 80px)' }}>

                            <label style={labelStyle}>Name</label>
                            <input type="text" value={a.name} onChange={this.editField('name')} style={inputStyle} placeholder="e.g. Look Up Customer" autoFocus />

                            <label style={labelStyle}>Description</label>
                            <textarea value={a.description} onChange={this.editField('description')} rows={3}
                                placeholder="Describe what this action does. The AI will use this to decide when and how to call it."
                                style={{ width: '100%', padding: '9px 12px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '14px', color: '#222', background: '#fff', boxSizing: 'border-box', marginBottom: '20px', resize: 'vertical' }}
                            />

                            {/* Execution — how this action runs */}
                            <div style={sectionStyle}>
                                <label style={Object.assign({}, labelStyle, { color: '#6c3483' })}>Execution</label>
                                <input type="text" value={a.endpoint || ''} placeholder={'Endpoint (defaults to "' + (a.id || 'action id') + '")'}
                                    onChange={this.editField('endpoint')}
                                    style={{ width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', marginBottom: '10px' }} />
                                <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.5' }}>
                                    When this action fires, the AI engine POSTs to /tools/{(a.endpoint && a.endpoint.trim()) || a.id || 'action-id'} on the tool service. The tool service URL is configured in diva-ai (TOOL_SERVICE_URL).
                                </div>
                            </div>

                            {/* Inputs */}
                            <div style={sectionStyle}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                                    <label style={Object.assign({}, labelStyle, { marginBottom: 0, color: '#1a5276' })}>Inputs</label>
                                    <button onClick={this.addInput}
                                        style={{ background: 'none', border: '1px solid #1a5276', borderRadius: '5px', color: '#1a5276', fontSize: '12px', fontWeight: '700', padding: '3px 10px', cursor: 'pointer' }}>
                                        + Add
                                    </button>
                                </div>
                                {a.inputs.length === 0 && (
                                    <div style={{ fontSize: '13px', color: '#aaa', fontStyle: 'italic' }}>No inputs — this action takes no parameters.</div>
                                )}
                                {a.inputs.map(function(inp, idx) {
                                    return (
                                        <div key={idx} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
                                            <div style={{ flex: '0 0 120px' }}>
                                                <input type="text" value={inp.name} placeholder="Field name"
                                                    onChange={function(i, e) { this.editInput(i, 'name', e.target.value); }.bind(this, idx)}
                                                    style={{ width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', fontWeight: '600', boxSizing: 'border-box' }} />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <textarea value={inp.description} placeholder="Describe this field (e.g. The caller's phone number)" rows={2}
                                                    onChange={function(i, e) { this.editInput(i, 'description', e.target.value); }.bind(this, idx)}
                                                    style={{ width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.4' }} />
                                            </div>
                                            <button onClick={function(i) { this.removeInput(i); }.bind(this, idx)}
                                                style={{ background: 'none', border: 'none', color: '#c0392b', fontSize: '18px', cursor: 'pointer', flexShrink: 0, paddingTop: '4px' }}>×</button>
                                        </div>
                                    );
                                }.bind(this))}
                            </div>

                            {/* Outputs */}
                            <div style={sectionStyle}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                                    <label style={Object.assign({}, labelStyle, { marginBottom: 0, color: '#1a6e4a' })}>Outputs</label>
                                    <button onClick={this.addOutput}
                                        style={{ background: 'none', border: '1px solid #1a6e4a', borderRadius: '5px', color: '#1a6e4a', fontSize: '12px', fontWeight: '700', padding: '3px 10px', cursor: 'pointer' }}>
                                        + Add
                                    </button>
                                </div>
                                {a.outputs.length === 0 && (
                                    <div style={{ fontSize: '13px', color: '#aaa', fontStyle: 'italic' }}>No outputs — this action returns nothing.</div>
                                )}
                                {a.outputs.map(function(out, idx) {
                                    return (
                                        <div key={idx} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
                                            <div style={{ flex: '0 0 140px' }}>
                                                <input type="text" value={out.name} placeholder="Field name"
                                                    onChange={function(i, e) { this.editOutput(i, 'name', e.target.value); }.bind(this, idx)}
                                                    style={{ width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', fontWeight: '600', boxSizing: 'border-box' }} />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <textarea value={out.description} placeholder="Describe what this field contains (e.g. Customer's full name)" rows={2}
                                                    onChange={function(i, e) { this.editOutput(i, 'description', e.target.value); }.bind(this, idx)}
                                                    style={{ width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.4' }} />
                                            </div>
                                            <button onClick={function(i) { this.removeOutput(i); }.bind(this, idx)}
                                                style={{ background: 'none', border: 'none', color: '#c0392b', fontSize: '18px', cursor: 'pointer', flexShrink: 0, paddingTop: '4px' }}>×</button>
                                        </div>
                                    );
                                }.bind(this))}
                            </div>

                            {this.state.error && <div className="error" style={{ marginBottom: '12px' }}>{this.state.error}</div>}

                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                {!a._isNew && <DeleteButton onClick={this.confirmDelete} />}
                                <SaveButton onClick={this.save}>{a._isNew ? 'Create' : 'Save'}</SaveButton>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }


        // ── Card grid ──────────────────────────────────────────────────────────
        return (
            <div style={{ padding: '24px', maxWidth: '1100px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '20px' }}>
                    <div style={{ fontWeight: '700', fontSize: '13px', letterSpacing: '1px', textTransform: 'uppercase', color: '#888', flexShrink: 0 }}>Actions</div>
                    {allEntries.length > 0 && (
                        <input
                            type="text"
                            value={this.state.searchQuery}
                            onChange={function(e) { this.setState({ searchQuery: e.target.value }); }.bind(this)}
                            placeholder="Search actions..."
                            style={{ flex: 1, maxWidth: '300px', padding: '6px 12px', border: '1px solid #dde3ea', borderRadius: '6px', fontSize: '13px', outline: 'none' }}
                        />
                    )}
                    {allEntries.length > 0 && (
                        <div style={{ fontSize: '12px', color: '#aaa', marginLeft: 'auto', flexShrink: 0 }}>
                            {searchQuery ? actionEntries.length + ' of ' + allEntries.length : allEntries.length} {allEntries.length === 1 ? 'action' : 'actions'}
                        </div>
                    )}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '18px' }}>

                    {/* Add card */}
                    <div onClick={this.openAdd} style={Object.assign({}, cardStyle, {
                        border: '2px dashed #b0bec5', background: '#f7f9fc',
                        alignItems: 'center', justifyContent: 'center', minHeight: '140px', color: '#90a4ae'
                    })}>
                        <div style={{ fontSize: '32px', lineHeight: 1, marginBottom: '8px' }}>+</div>
                        <div style={{ fontSize: '14px', fontWeight: '600' }}>New Action</div>
                    </div>

                    {actionEntries.map(function([actionId, action]) {
                        var count = usedBy[actionId] || 0;
                        var inputs = action.inputs || [];
                        var outputs = action.outputs || [];
                        return (
                            <div key={actionId} onClick={this.openEdit(actionId, action)} style={cardStyle}>
                                <div style={{ fontWeight: '700', fontSize: '15px', color: '#222', marginBottom: '8px' }}>{action.name}</div>
                                {action.description && (
                                    <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.5', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', marginBottom: '10px' }}>
                                        {action.description}
                                    </div>
                                )}
                                <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                                    <span style={{ background: '#eaf3fb', color: '#1a5276', borderRadius: '4px', padding: '3px 9px', fontSize: '11px', fontWeight: '700' }}>
                                        {inputs.length} input{inputs.length !== 1 ? 's' : ''}
                                    </span>
                                    <span style={{ background: '#eafaf1', color: '#1a6e4a', borderRadius: '4px', padding: '3px 9px', fontSize: '11px', fontWeight: '700' }}>
                                        {outputs.length} output{outputs.length !== 1 ? 's' : ''}
                                    </span>
                                </div>
                                <div style={{ marginTop: 'auto', fontSize: '11px', color: count > 0 ? '#1a6e4a' : '#aaa', fontWeight: count > 0 ? '600' : '400' }}>
                                    {count > 0 ? 'Used by ' + count + ' bot' + (count === 1 ? '' : 's') : 'Not linked to any bots'}
                                </div>
                            </div>
                        );
                    }.bind(this))}
                </div>

                {modal}
            </div>
        );
    }
}

const icon = "menuGear";
const roles = ["View", "Add", "Edit", "Delete"];
export { Actions, icon, roles };
